// src/components/LeadershipMessages.tsx
import React from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './LeadershipMessages.css';

interface Leader {
  id: number;
  name: string;
  role: string;
  image: string;
  message: string;
}

const LeadershipMessages: React.FC = () => {
  const leaders: Leader[] = [
    {
      id: 1,
      name: "Mr. Rajesh Singh",
      role: "Chairperson",
      image: "/images/leadership/chairperson.jpeg",
      message:
        "Dear Parents and Well-Wishers,\n\n" +
        "It gives me great joy to welcome you to New ABC Montessori School, a place where every child is encouraged to dream, learn, and grow with confidence.\n" +
        "Our vision is to provide quality education that builds both knowledge and character. We believe that true learning happens when children are happy, curious, and free to explore their ideas.\n" +
        "Together, we can make every child’s journey meaningful and joyful."
    },
    {
      id: 2,
      name: "Mrs. Namita Singh",
      role: "Principal",
      image: "/images/leadership/principal.jpeg",
      message:
        "Dear Parents and Guardians,\n\n" +
        "Welcome to New ABC Montessori School, where learning is joyful and every child is valued.\n" +
        "We follow the Montessori philosophy to nurture curiosity, creativity, and confidence.\n" +
        "Together with parents, we look forward to guiding our students toward a bright future."
    },
    {
      id: 3,
      name: "Mr. Vedansh Singh",
      role: "Board Member",
      image: "/images/leadership/youngmind.jpeg",
      message:
        "Dear Parents and Guardians,\n\n" +
        "With a young mind and a forward-looking vision, I am proud to be part of a school that nurtures curiosity and innovation.\n" +
        "As the youngest voice on the board, my aim is to blend modern thinking with strong values, preparing children for tomorrow’s challenges."
    }
  ];

  return (
    <section className="leadership-messages">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Leadership & Vision</h2>
          <p className="section-subtitle">
            Guiding Principles from Our Esteemed Leaders
          </p>
        </div>

        <Carousel
          fade
          controls={false}
          indicators
          interval={8000}
          className="leadership-carousel"
        >
          {leaders.map((leader) => (
            <Carousel.Item key={leader.id} className="leadership-item">
              <div className="row g-0 align-items-center">
                <div className="col-lg-5">
                  <div className="leader-image-wrapper p-4">
                    <img
                      src={leader.image}
                      alt={leader.name}
                      className="img-fluid leader-image rounded"
                    />
                  </div>
                </div>

                <div className="col-lg-7">
                  <div className="leader-message">
                    <div className="leader-role">
                      {leader.role}'s Message
                    </div>
                    <h2 className="leader-name">{leader.name}</h2>
                    <div className="divider"></div>

                    <p className="leader-text">
                      {leader.message.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default LeadershipMessages;
